import * as React from 'react';
import { SepaContainer } from '../../../containers/Adyen/Sepa/SepaContainer.js';

const Sepa = ({ onChange  })=>{
    const handleChange = React.useCallback((state)=>{
        onChange(state.data, state.isValid);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(SepaContainer, {
        onChange: handleChange
    });
};

export { Sepa };
//# sourceMappingURL=Sepa.js.map
